import { FormattedMessage } from "react-intl";

const SectionTitle = (props: any) => {
  return (
    <>
      {props.clarification ? (
        <p className="font-fitprenda-section-title">
          {props.title ? (
            <FormattedMessage id={props.title} defaultMessage={props.title} />
          ) : (
            ""
          )}{" "}
          <span style={{ fontWeight: 400, fontSize: "14px" }}>
            <FormattedMessage id={props.clarification} />
          </span>
        </p>
      ) : (
        <p className="font-fitprenda-section-title">
          {props.title ? (
            <FormattedMessage id={props.title} defaultMessage={props.title} />
          ) : (
            ""
          )}
        </p>
      )}
    </>
  );
};

export default SectionTitle;
